
import { BabyFoodTracker } from './ui.js';
document.addEventListener('DOMContentLoaded', () => {
    new BabyFoodTracker();
});
